import { getPortalServiceApi } from '../../rmx-service/api/portal-api';
import { openBypassModal } from './MenuModal';
import type { OrgLevel } from '../../../api/userDashboardApi';
import { assert } from '../../utils';
import { type BypassTarget } from 'src/portal/utils/BypassModal/BypassModal';
/* eslint-disable */
declare global {
  interface Window {
    getSelectedRow: () => ActiveAlertRow;
    openAlertDetailsModal: (alert: ActiveAlertRow) => void;
    initializeActiveAlertsMenu: (row: ActiveAlertRow, type: OrgLevel, modalTitle: string, onBypass?: () => Promise<unknown>) => void;
  }
}
export interface ActiveAlertRow {
  Company: string;
  Site: string;
  System: string;
  Asset: string;
  Model: string;
  SN: string;
  AlertStatus: string;
  Alert: string;
  AlertDescription: string;
  AlertResponse: string;
  Start: string;
  SiteID: number;
  CompanyID: number;
  CompanyGUID: string | null;
  SiteGUID: string | null;
  InstallationID: number;
  InstallationName: string;
  AssetId: number | null;
  SystemProcessId: number | null;
  RmxBoxId: number | null;
  Color: AlertRowColor;
  Severity: number;
  Subject: string;
  Type: 'System' | 'Asset';
}

function getBypassTargetFromAlertTableRow(row: ActiveAlertRow): BypassTarget | null {
  if (row.AssetId != null) {
    return 'Asset';
  } else if (row.RmxBoxId != null) {
    return 'Hub';
  } else if (row.SystemProcessId != null) {
    return 'SystemProcess';
  } else if (row.SiteID != null) {
    return 'Site';
  }
  return null;
}

export type AlertRowColor = 'red' | 'orange' | 'gray' | 'blue';
// @ts-ignore
window.initializeActiveAlertsMenu = async function ActiveAlertsModalMenu(row: ActiveAlertRow, type, modalTitle, onBypass) {
  const assetName = modalTitle;
  const rmxApi = getPortalServiceApi();
  const syncedUser = await rmxApi.syncedUser();

  const bypassTarget = getBypassTargetFromAlertTableRow(row);

  assert(bypassTarget !== null, `Alert Table Error: Asset Id, System Process Id and Rmx Hub Id are all null for the selected row`);

  const rowId = row.AssetId != null ? row.AssetId : row.RmxBoxId != null ? row.RmxBoxId : row.SystemProcessId != null ? row.SystemProcessId : null;

  assert(rowId !== null, `Alert Table Error: Asset Id, System Process Id and Rmx Hub Id are all null for the selected row`);

  const menuConfig = {
    details: () => {
      window.openAlertDetailsModal(row);
    },

    open_site: () => {
      window.location.href = `${window.origin}?p=InstallationPage&pid=${row.SiteGUID}`;
    },

    getLabel: () => assetName,
    bypass: () => {
      openBypassModal({
        id: rowId,
        serial: row.SN,
        model: row.Model,
        companyGuid: row.CompanyGUID ?? undefined,
        siteGuid: row.SiteGUID ?? undefined,
        syncedUser: syncedUser,
        target: bypassTarget
      });
    }
  };

  window.OpenMenuModal(modalTitle, menuConfig);
};

function getSelectedRow(): ActiveAlertRow {
  // @ts-ignore
  return window.selectedSiteRow || window.selectedRow;
}

window.openAlertDetailsModal = (value: ActiveAlertRow) => {
  const row = value ?? getSelectedRow();
  const $alertDetailsDialog = $('#alert-details-dialog');
  $alertDetailsDialog.dialog({ title: row.Company + ' - ' + row.Site });
  const details = [
    ['Alert', row.Alert],
    ['Cause', row.AlertDescription],
    ['Response', row.AlertResponse],
    ['System', row.System],
    ['Asset', row.Asset],
    ['Model', row.Model],
    ['SN', row.SN]
  ];
  const htmlDetails = details.map((d) => `<b>${d[0]}:</b> ${d[1]}`).join('<br/>');
  $alertDetailsDialog.html(htmlDetails);
  $alertDetailsDialog.dialog('open');
};
